import injected from "./injected";
import walletconnect from "./walletconnect";
import portis from "./portis";
import fortmatic from "./fortmatic";
import torus from "./torus";
import squarelink from "./squarelink";
import arkane from "./arkane";
import authereum from "./authereum";
import burnerconnect from "./burnerconnect";
import unilogin from "./unilogin";
import mewconnect from "./mewconnect"
import dcentwallet from "./dcentwallet";

export {
  injected,
  walletconnect,
  portis,
  torus,
  fortmatic,
  squarelink,
  arkane,
  authereum,
  burnerconnect,
  unilogin,
  mewconnect,
  dcentwallet
};
